export type CentralReprocessamentoTamanho = 'PEQUENO' | 'MEDIO' | 'GRANDE';

export const CENTRAL_REPROCESSAMENTO_TAMANHO: Record<CentralReprocessamentoTamanho, string> = {
  PEQUENO: 'Pequeno',
  MEDIO: 'Médio',
  GRANDE: 'Grande',
};
